export enum FileType {
    Csv = 1,
    Excel = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/filetype.enum.ts